var map = {
	"./cardM/announcement/v1_HK02595/index.js": 10968,
	"./cardM/custom/v1_HK02595/index.js": 30206,
	"./cardM/news/v1_HK02595/index.js": 57864,
	"./cardM/report/v1_HK02595/index.js": 17510,
	"./cardM/widget_shell/v1_HK02595/index.js": 19115,
	"./flow/announcement/v1/index.js": 176,
	"./flow/appointment/v1/index.js": 96504,
	"./flow/banner/v1/index.js": 96839,
	"./flow/company_profile_hk00656/v1/index.js": 73016,
	"./flow/corporate_governance/v1_HK00656/index.js": 98423,
	"./flow/custom/v1/index.js": 56640,
	"./flow/customs_calendar/v1/index.js": 78981,
	"./flow/institutional_holding/v1/index.js": 66698,
	"./flow/investment_activity/v1/index.js": 92846,
	"./flow/leave_word/v1/index.js": 10433,
	"./flow/message_subscription/v1/index.js": 50922,
	"./flow/news/v1/index.js": 98648,
	"./flow/offline/v1/index.js": 35970,
	"./flow/question/v1/index.js": 28441,
	"./flow/quote/v1/index.js": 82807,
	"./flow/quote/v1_SH601898/index.js": 9323,
	"./flow/quote/v1_SH603605/index.js": 53237,
	"./flow/quote/v1_SH688131/index.js": 79634,
	"./flow/report/v1/index.js": 25071,
	"./flow/research/v1/index.js": 41450,
	"./flow/roadshow/v1/index.js": 35464,
	"./flow/shareholder/v1/index.js": 2192,
	"./flow/shareholder_count/v1/index.js": 98996,
	"./flow/shareholder_meeting/v1/index.js": 62765,
	"./flow/summary_sh601231/v1/index.js": 61316,
	"./flow/top_ten_shareholder/v1/index.js": 29600,
	"./flow/us_announcement/v1/index.js": 24109,
	"./tmpl/analyst/v1/index.js": 98130,
	"./tmpl/announcement/v1/index.js": 39987,
	"./tmpl/announcement/v1_HK02276/index.js": 45827,
	"./tmpl/appointment/v1/index.js": 11921,
	"./tmpl/banner/v1/index.js": 92491,
	"./tmpl/company_culture_sz300957/v1_SZ300957/index.js": 74095,
	"./tmpl/company_profile/v1/index.js": 7074,
	"./tmpl/company_profile_sz300957/v1_SZ300957/index.js": 44907,
	"./tmpl/contact_information/v1_HK02276/index.js": 62883,
	"./tmpl/corporate_governance/v1/index.js": 33829,
	"./tmpl/custom/v1/index.js": 23987,
	"./tmpl/custom/v1_HK02276_168/index.js": 31908,
	"./tmpl/customs_calendar/v1/index.js": 72374,
	"./tmpl/dividend_plan/v1/index.js": 92263,
	"./tmpl/esg/v1/index.js": 51793,
	"./tmpl/finance_data/v1/index.js": 85507,
	"./tmpl/finance_data/v1_HK02276/index.js": 99365,
	"./tmpl/finance_data/v1_HK02373/index.js": 48207,
	"./tmpl/fund_holding/v1/index.js": 59038,
	"./tmpl/institutional_holding/v1/index.js": 62011,
	"./tmpl/investment_activity/v1/index.js": 34607,
	"./tmpl/investment_activity/v1_HK02276/index.js": 27947,
	"./tmpl/investment_activity/v1_HK09606/index.js": 84474,
	"./tmpl/leave_word/v1/index.js": 45238,
	"./tmpl/margin_funds/v1/index.js": 90114,
	"./tmpl/message_subscription/v1/index.js": 1769,
	"./tmpl/news/v1/index.js": 448,
	"./tmpl/north_south_funds/v1/index.js": 32885,
	"./tmpl/offline/v1/index.js": 239,
	"./tmpl/performance_report/v1/index.js": 26338,
	"./tmpl/quarterly_performance/v1/index.js": 45732,
	"./tmpl/quarterly_performance/v1_HK02172/index.js": 70165,
	"./tmpl/quarterly_performance/v1_SH688050/index.js": 14994,
	"./tmpl/quarterly_performance/v1_SZ300957/index.js": 25380,
	"./tmpl/question/v1/index.js": 30850,
	"./tmpl/question/v1_SH688050/index.js": 88871,
	"./tmpl/quote/v1/index.js": 43110,
	"./tmpl/quote/v1_HK09606/index.js": 81731,
	"./tmpl/quote/v1_SH601898/index.js": 22772,
	"./tmpl/quote/v1_SH603605/index.js": 350,
	"./tmpl/quote/v1_SZ002242/index.js": 20878,
	"./tmpl/quote/v1_SZ300957/index.js": 86989,
	"./tmpl/quote_hk02276/v1/index.js": 32372,
	"./tmpl/report/v1/index.js": 27450,
	"./tmpl/report/v1_HK02276/index.js": 10158,
	"./tmpl/report/v1_HK09606/index.js": 41266,
	"./tmpl/research/v1/index.js": 63961,
	"./tmpl/roadshow/v1/index.js": 93715,
	"./tmpl/shareholder/v1/index.js": 56191,
	"./tmpl/shareholder_count/v1/index.js": 52973,
	"./tmpl/top_ten_shareholder/v1/index.js": 28297,
	"./tmpl/us_announcement/v1/index.js": 36688,
	"./tmpl/widget_shell/v1/index.js": 69597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78828;